<div class="container-fluid padMob bg webView bggray" style="padding-left: 25px; padding-right: 15px;">
  <div class="row">
    <div class="col-md-12 col-12 col-sm-12 custom-padleft padHeder" style="padding-bottom: 0px;">
      <div class="col-md-6 col-sm-6 col-6 inLneBlk pad0">
        <h2>{{viewHeading}}</h2>
      </div>
      <div class="col-md-6 col-sm-6 col-6 inLneBlk pad0 text-right">
        <div style="display: inline-block;">
          <label
            style="margin-left: 10px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
            for="sel1">Month : </label>
        </div>
        <div style="display: inline-block;">
          <select class="form-control bdrrd5 bgwhite" style="box-shadow: none;" [(ngModel)]="view.month" tabindex="1">
            <option [value]="i.id" *ngFor="let i of months;">{{i.display}}</option>
          </select>
        </div>
        <div style="display: inline-block;">
          <span class="search">
            <span class="fa fa-search" style="font-size: 13px;"></span>
            <input class="form-control brdrColor" matInput ng-model="search.term" (keyup)="applyFilter($event)" #input
              placeholder="Search"
              style="font-size: 13px !important; text-align: left;display: inline-block; padding: 15px 35px;border-radius: 25px !important; box-shadow: none;width: 92%;vertical-align:inherit;"
              type="text">
          </span>
        </div>
        <div style="display: inline-block;">
          <span (click)="exportToExcel()" class="btn btn-teal fntSz" title="Export to Excel"
            style="cursor:pointer;margin-left: 10px;line-height: 23px;padding: 5px 9px;">
            <span>
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </span>
          </span>
          <span class="btn-blue"
            style="font-size: 13px; display: inline-block; padding: 5px 12px 6px; margin-left: 10px;"
            (click)="backBtn()">
            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
          </span>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-12 col-sm-12 custom-padleft padHeder" style="padding-bottom: 0px;">
      <div class="row">
        <div *ngIf="hideBtnstatus" class="col-md-8 col-8 col-sm-8 pad0 padHeder" style="padding-top: 10px;">
          <span class="label orangeBadge fntSz font13 {{statusID !== 1 && statusID !== 2? 'activeOrange' : ''}}"
            (click)="typeFilter(0)" style="cursor: pointer;">
            Sales
            <span style="font-size: 13px !important; font-weight: 600;"> </span>
          </span>
          <span class="label yellowBadge fntSz font13 {{statusID == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
            style="margin-left: 10px;cursor: pointer;">
            Credit Notes
            <span style="font-size: 13px; font-weight: 600;"></span>
          </span>
          <span class="label greenBadge fntSz font13 {{statusID == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
            style="margin-left: 10px;cursor: pointer;">
            <span>
              Debit Notes
            </span>
            <span style="font-size: 13px; font-weight: 600;"></span>
          </span>
        </div>
        <div *ngIf="viewBtnstatus" class="col-md-4 col-4 col-sm-3 pad0 padHeder text-left" style="padding-top: 10px;">
          <span class="label blueBadge fntSz font13 {{statusID == 3 || statusID == 0 ? 'activeBlue' : ''}}"
            (click)="typeFilter(3)" style="margin-left: 10px;cursor: pointer;">
            All
            <span style="font-size: 13px; font-weight: 600;"></span>
          </span>
          <span class="label darkBlueBadge fntSz font13 {{statusID == 4 ? 'activedarkblue' : ''}}"
            (click)="typeFilter(4)" style="margin-left: 10px;cursor: pointer;">
            B2B
            <span style="font-size: 13px; font-weight: 600;"></span>
          </span>
          <span class="label greenBadge font13 {{statusID == 5 ? 'activeGreen' : ''}}" (click)="typeFilter(5)"
            style="cursor: pointer; margin-left: 10px;"><span>B2CS</span>
          </span>
          <span class="label yellowBadge font13 {{statusID == 6 ? 'activeYellow' : ''}}" (click)="typeFilter(6)"
            style="cursor: pointer; margin-left: 10px;"><span>B2CL</span>
          </span>
        </div>
      </div>
    </div>

    <div class="col-md-12 col-12 col-sm-12 custom-padding-box">
      <div class="row">
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass orangeStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total Transaction</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">9</p>
            </div>
          </div>
        </div>
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass yellowStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total Taxable</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">₹ 4,37,932.00</p>
            </div>
          </div>
        </div>
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass greenStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total IGST</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">₹ 1,560.60</p>
            </div>
          </div>
        </div>
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass tealStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total SGST</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">₹ 13,786.02</p>
            </div>
          </div>
        </div>
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass blueStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total CGST</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">₹ 13,786.02</p>
            </div>
          </div>
        </div>
        <div class="col-md-2 padHeder">
          <div class="dashBox dashBox-stats alignClass darkBlueStaticsBtn">
            <div class="dashBox-coloured-header">
              <h3 class="dashBox-title">Total Amount</h3>
              <p class="dashBox-category overrideDescriptionBottomCard reportDesc">₹ 4,67,064.64</p>
            </div>
          </div>
        </div>


      </div>
    </div>

    <div class="col-md-12 col-12 col-sm-12 custom-padleft">
      <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow">
        <table mat-table [dataSource]="dataSource" class="custom-align-table" matSort
          style="width: 100%;border-radius: 10px;">
          <!-- Position Column -->
          <ng-container matColumnDef="dt">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header> <label>Date</label> </th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.dt}} </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="invoiceNo">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header> <label>Invoice No.
              </label></th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.invoiceNo}} </td>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="customer">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header> <label>Customer </label>
            </th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.customer}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="gstIn">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> GSTIN</label>
            </th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.gstIn}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="taxAmt">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> Taxable Amt
              </label></th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;text-align: right; padding-right: 25px;"> ₹
              {{element.taxAmt | lacFormat}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="igst">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> IGST</label> </th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;">₹ {{element.igst | lacFormat}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="sgst">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> SGST </label></th>
            <td mat-cell *matCellDef="let element" style="cursor: pointer;">₹ {{element.sgst | lacFormat}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="cgst">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> CGST </label></th>
            <td mat-cell *matCellDef="let element">₹ {{element.cgst | lacFormat}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="totalAmt">
            <th class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header><label> Total Amt </label>
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: right; padding-right: 25px;"> ₹ {{element.totalAmt
              | lacFormat}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="type">
            <th [hidden]="hide" class="header header-Table" mat-header-cell *matHeaderCellDef mat-sort-header
              [class.customHidden]='statusID !== 0 && statusID !== 3'><label> Type </label></th>
            <td [hidden]="show" mat-cell *matCellDef="let element"
              [class.customHidden]='statusID !== 0 && statusID !== 3'> {{element.type}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,20,30]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
<!-- Mobile View -->
<div class="container-fluid padMob bg mobView" style="padding-left: 15px; padding-right: 0px;">
  <div class="row">
    <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-bottom: 0px;">
      <div class="col-md-10 col-10" style="display: inline-block;padding: 0px;">
        <h4> Sales Summary </h4>
      </div>
      <div class="col-md-2 col-2" style="display: inline-block;padding-right: 10px;
          top: 7px;">
        <a (click)="backToHomeBtn()" class=" mobViewBtn mobView" target="_blank"
          style="padding: 4px 0px 4px 14px; font-size: 16px; float: right; line-height: 1.66em; margin-right: 7px;display: inline-block;">
          <i aria-hidden="true" class="fa fa-bars "></i>
        </a>
      </div>
    </div>
    <div *ngIf="hideBtnstatus" class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-top: 10px;">
      <span class="label orangeBadge fntSz font13 {{statusID !== 1 && statusID !== 2? 'activeOrange' : ''}}"
        (click)="typeFilter(0)" style="cursor: pointer;">
        Sales
        <span style="font-size: 13px !important; font-weight: 600;"> </span>
      </span>
      <span class="label yellowBadge fntSz font13 {{statusID == 1 ? 'activeYellow' : ''}}" (click)="typeFilter(1)"
        style="margin-left: 10px;cursor: pointer;">
        Credit Notes
        <span style="font-size: 13px; font-weight: 600;"></span>
      </span>
      <span class="label greenBadge fntSz font13 {{statusID == 2 ? 'activeGreen' : ''}}" (click)="typeFilter(2)"
        style="margin-left: 10px;cursor: pointer;">
        Debit Notes
        <span style="font-size: 13px; font-weight: 600;"></span>
      </span>
    </div>
    <div *ngIf="viewBtnstatus" class="col-md-12 col-12 col-sm-12 bgWhite padHeder" style="padding-top: 1px;">
      <span class="label blueBadge fntSz font13 {{statusID == 3 || statusID == 0 ? 'activeBlue' : ''}}"
        (click)="typeFilter(3)" style="cursor: pointer;">
        All
      </span>
      <span class="label darkBlueBadge fntSz font13 {{statusID == 4 ? 'activedarkblue' : ''}}" (click)="typeFilter(4)"
        style="margin-left: 10px;cursor: pointer;">
        B2B
      </span>
      <span class="label greenBadge font13 {{statusID == 5 ? 'activeGreen' : ''}}" (click)="typeFilter(5)"
        style="cursor: pointer; margin-left: 10px;">
        B2CS
      </span>
      <span class="label yellowBadge font13 {{statusID == 6 ? 'activeYellow' : ''}}" (click)="typeFilter(6)"
        style="cursor: pointer; margin-left: 10px;">
        B2CL
      </span>
    </div>
    <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder mobView" style="padding: 0px 30px 10px 15px;">
      <div class="input-icons search">
        <span class="fa fa-search"></span>
        <input class="form-control brdrColor" matInput [(ngModel)]="search" placeholder="Search"
          style="padding-left: 35px !important; padding: 15px; border-color: #E4E4E4; border-radius: 25px !important; box-shadow: none; border: 1px solid #e4e4e4 !important; width: 84%; float: left;"
          type="text">
      </div>
    </div>
    <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder"
      style="padding-top: 7px !important; padding-bottom: 10px; padding-right: 0px;">
      <div style="display: inline-block;">
        <label
          style="margin-left: 10px; font-size: 14px; display: inline-block; margin-bottom:0px; font-weight: normal;"
          for="sel1">Month : </label>
      </div>
      <div style="display: inline-block;">
        <select class="form-control bgwhite" style="box-shadow: none;" [(ngModel)]="view.month" tabindex="1">
          <option [value]="i.id" *ngFor="let i of months;">{{i.display}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-12 col-12 col-sm-12 pad0">
      <div class="col-md-12 col-sm-12 col-12 pad0 bgWhite pad15 marginTp font13"
        *ngFor="let x of listData | filter:'customer,invoiceNo,type,gstIn':search">
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
            <span style="font-weight: bold;">{{x.customer}}</span>
          </div>
          <div class="col-md-4 col-4 col-sm-4 pad0 inLneBlk txtRight">
            <span style="color: #4caf50;">{{x.invoiceNo}}</span>
          </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12">
            <span style="margin-right: 5px; color: #e88421;"><i class="zmdi zmdi-view-dashboard"></i></span>
            <span style="color: #777;">{{x.type}}</span>
          </div>
          <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12">
            <span style="color: #777;">{{x.dt | date:'dd-MMM-yy'}}</span>
          </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0">
          <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12">
            <span style="position: relative; margin-right: 5px;"> <i class="fa fa-calendar" style="color: #1f628e;"></i>
            </span> <span style="color: #777;">{{x.gstIn}}</span>
          </div>
          <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12">
            <span style="color: #777;">INR {{x.totalAmt | lacFormat}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>